import { render, staticRenderFns } from "./Organism3DContainer.vue?vue&type=template&id=20b47bea&"
import script from "./Organism3DContainer.vue?vue&type=script&lang=js&"
export * from "./Organism3DContainer.vue?vue&type=script&lang=js&"
import style0 from "./Organism3DContainer.vue?vue&type=style&index=0&id=20b47bea&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {OrganismsProjectOrganismBuildingErrorOccurred: require('/app/components/organisms/project/OrganismBuildingErrorOccurred.vue').default,OrganismsProjectOrganismBuildingLoader: require('/app/components/organisms/project/OrganismBuildingLoader.vue').default,OrganismsProjectBuildingOrganismBuilding: require('/app/components/organisms/project/building/OrganismBuilding.vue').default})
